import PropTypes from "prop-types";
import { SERIES_CONFIG } from "../constants";
import "./ChartLegend.scss";

const ChartLegend = ({ visibility, onToggle, events = [] }) => {
  const hasEvents = events && events.length > 0;

  return (
    <div className="chart-legend">
      {/* Series legend items */}
      {SERIES_CONFIG.map(cfg => (
        <div
          key={cfg.name}
          role="button"
          tabIndex={0}
          onClick={() => onToggle(cfg.name)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggle(cfg.name);
            }
          }}
          className={`chart-legend__item ${!visibility[cfg.name] ? "chart-legend__item--hidden" : ""}`}
        >
          <div
            className={`chart-legend__swatch ${cfg.chartType === "bar" ? "chart-legend__swatch--bar" : ""}`}
            style={{ backgroundColor: cfg.color }}
          />
          <span className="chart-legend__label">{cfg.name}</span>
        </div>
      ))}

      {/* Single Events legend item */}
      {hasEvents && (
        <div
          key="events"
          role="button"
          tabIndex={0}
          onClick={() => onToggle("events")}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onToggle("events");
            }
          }}
          className={`chart-legend__item ${!visibility["events"] ? "chart-legend__item--hidden" : ""}`}
        >
          <div className="chart-legend__swatch chart-legend__swatch--events" />
          <span className="chart-legend__label">Events</span>
        </div>
      )}
    </div>
  );
};

ChartLegend.propTypes = {
  visibility: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggle: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      eventName: PropTypes.string,
      date: PropTypes.string,
    })
  ),
};

ChartLegend.defaultProps = {
  events: [],
};

export default ChartLegend;
